var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: {
          rules: _vm.requiredEmails ? "hasEmail" : "",
          name: _vm.nomeAba + "/Email(s)"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c("el-table", {
                  attrs: { hidden: "hidden", data: _vm.emails },
                  model: {
                    value: _vm.emailsValidationValues,
                    callback: function($$v) {
                      _vm.emailsValidationValues = $$v
                    },
                    expression: "emailsValidationValues"
                  }
                })
              ]
            }
          }
        ])
      }),
      _c(
        "validation-provider",
        {
          attrs: {
            rules: _vm.requiredEmails
              ? "email:@" + _vm.nomeAba + "/Email(s)"
              : "",
            name: "$ignoreEmail$"
          }
        },
        [
          _c("app-label", {
            attrs: { label: "Email(s):", required: _vm.requiredEmails }
          }),
          _c(
            "el-input",
            {
              staticClass: "input",
              class: { erro: _vm.errorsEmail && _vm.errorsEmail.length },
              attrs: { label: "Email" },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            },
            [
              _c("el-button", {
                staticClass: "style",
                attrs: {
                  slot: "append",
                  icon: "el-icon-plus",
                  disabled: !_vm.isEmailValid
                },
                on: {
                  click: function($event) {
                    return _vm.addEmail(_vm.email)
                  }
                },
                slot: "append"
              })
            ],
            1
          ),
          _c("span", { staticClass: "help erro" }, [
            _vm._v(_vm._s(_vm.errorsEmail ? _vm.errorsEmail[0] : ""))
          ]),
          _c(
            "div",
            { staticClass: "tag-app-input marginTop" },
            _vm._l(_vm.emails, function(email, index) {
              return _c(
                "el-tag",
                {
                  key: index,
                  attrs: { closable: "closable", type: "info", size: "medium" },
                  on: {
                    close: function($event) {
                      return _vm.removeEmail(index)
                    }
                  }
                },
                [_vm._v(_vm._s(email))]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-265c8573", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-265c8573","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppInputEmail.vue
// module id = null
// module chunks = 